package features.auth.data

import features.auth.domain.User
import features.auth.domain.AuthRepository
import core.firebase.FirebaseService
import kotlin.js.Promise

class FirebaseAuthRepository : AuthRepository {
    
    override fun signInWithGoogle(): Promise<User> {
        return FirebaseService.signInWithGoogle()
            .then { userCredential ->
                val firebaseUser = userCredential.user
                User(
                    id = firebaseUser.uid,
                    name = firebaseUser.displayName ?: "Unknown",
                    email = firebaseUser.email ?: "",
                    avatar = firebaseUser.photoURL
                )
            }
    }
    
    override fun signOut(): Promise<Unit> {
        return FirebaseService.signOut()
    }
    
    override fun getCurrentUser(): User? {
        val firebaseUser = FirebaseService.currentUser ?: return null
        return User(
            id = firebaseUser.uid,
            name = firebaseUser.displayName ?: "Unknown",
            email = firebaseUser.email ?: "",
            avatar = firebaseUser.photoURL
        )
    }
    
    override fun onAuthStateChanged(callback: (User?) -> Unit) {
        FirebaseService.onAuthStateChanged { firebaseUser ->
            if (firebaseUser != null) {
                callback(User(
                    id = firebaseUser.uid,
                    name = firebaseUser.displayName ?: "Unknown",
                    email = firebaseUser.email ?: "",
                    avatar = firebaseUser.photoURL
                ))
            } else {
                callback(null)
            }
        }
    }
}
